<section class="ganasocio-conflict-modal" role="dialog" aria-modal="true">
  <button
    type="button"
    class="ganasocio-conflict-modal__close"
    [attr.aria-label]="'buildYourNetwork.ganasocioConflict.close' | translate"
    (click)="close()"
  >
    <img src="assets/img/promotions/detail/modal-close-linear.svg" alt="" aria-hidden="true" />
  </button>

  <span class="ganasocio-conflict-modal__icon" aria-hidden="true">!</span>

  @switch (data.variant) {
    @case ('already-registered') {
      <div class="ganasocio-conflict-modal__copy">
        <h2>{{ 'buildYourNetwork.ganasocioConflict.alreadyRegistered.title' | translate }}</h2>
        <p>{{ 'buildYourNetwork.ganasocioConflict.alreadyRegistered.description' | translate }}</p>
      </div>
      <div class="ganasocio-conflict-modal__actions">
        <korviu-button
          class="ganasocio-conflict-modal__action"
          color="tertiary"
          size="large"
          (click)="close('add-new-referral')"
        >
          {{ 'buildYourNetwork.ganasocioConflict.actions.addNewReferral' | translate }}
        </korviu-button>
        <korviu-button class="ganasocio-conflict-modal__action" color="ghost" size="large" (click)="close('back')">
          {{ 'buildYourNetwork.ganasocioConflict.actions.back' | translate }}
        </korviu-button>
      </div>
    }
    @case ('duplicate-ganasocio') {
      <div class="ganasocio-conflict-modal__copy">
        <h2>{{ 'buildYourNetwork.ganasocioConflict.duplicateGanasocio.title' | translate }}</h2>
        <p>{{ 'buildYourNetwork.ganasocioConflict.duplicateGanasocio.description' | translate }}</p>
      </div>
      <div class="ganasocio-conflict-modal__actions">
        <korviu-button
          class="ganasocio-conflict-modal__action"
          color="tertiary"
          size="large"
          (click)="close('add-new-referral')"
        >
          {{ 'buildYourNetwork.ganasocioConflict.actions.addNewReferral' | translate }}
        </korviu-button>
        <korviu-button
          class="ganasocio-conflict-modal__action"
          color="ghost"
          size="large"
          (click)="close('see-invitation')"
        >
          {{ 'buildYourNetwork.ganasocioConflict.actions.seeInvitation' | translate }}
        </korviu-button>
      </div>
    }
    @case ('duplicate-other-type') {
      <div class="ganasocio-conflict-modal__copy">
        <h2>
          {{
            'buildYourNetwork.ganasocioConflict.duplicateOtherType.title'
              | translate: { userType: data.invitedUserTypeName }
          }}
        </h2>
        <p>
          {{
            'buildYourNetwork.ganasocioConflict.duplicateOtherType.description'
              | translate: { userType: data.invitedUserTypeName }
          }}
        </p>
      </div>
      <div class="ganasocio-conflict-modal__actions">
        <korviu-button
          class="ganasocio-conflict-modal__action"
          color="tertiary"
          size="large"
          (click)="close('cancel-invitation')"
        >
          {{ 'buildYourNetwork.ganasocioConflict.actions.cancel' | translate }}
        </korviu-button>
        <korviu-button
          class="ganasocio-conflict-modal__action"
          color="ghost"
          size="large"
          (click)="close('keep-invitation')"
        >
          {{
            'buildYourNetwork.ganasocioConflict.actions.keepInvitation'
              | translate: { userType: data.invitedUserTypeName }
          }}
        </korviu-button>
      </div>
    }
  }
</section>
